import React, { Component } from 'react'
import { connect } from 'react-redux'
import Link from 'redux-first-router-link'

import Datagrid from '@/ui/DataTable/Datagrid'
import ListTable from '@/ui/DataTable/List'

import generateUUID from '@/helpers/generateUUID'
import { getListParams } from '@/state/selectors'

import { Button } from '@/ui/Button'
import {
  ButtonField,
  BooleanField,
  DateField,
  TextField,
  TypeField,
  IndexField,
  CombinedField,
} from '@/ui/Data'
import { Card } from '@/ui/Card'
import { Container, Row, Cell } from '@/ui/Element'
import { EditButton, ButtonGroup } from '@/ui/Button'
import { Tooltip } from '@/ui/Tooltip'
import pad from '@/helpers/pad'

import {
  // ROUTE_DASHBOARD,
  ROUTE_COMPONENTS,
  ROUTE_PRODUCTS_NEW,
  ROUTE_NEWSLETTERS_NEW,
  ROUTE_NEWSLETTERS_EDIT,
} from '@/state/types/routes'

import SearchFilter from './Search'

import { routeNewslettersEdit, goToPage } from '@/state/actions/routes'

import { showModal, hideModal } from '@/state/actions/modal'
import { crudCreate, crudGetList, crudDelete, checkTemplate } from '@/state/actions/data' // eslint-disable-line
// import { showNotification } from '@/state/actions/notification'

import DeleteIcon from '@/icons/Delete'
import MailDownloadIcon from '@/icons/MailDownload'
import AddIcon from '@/icons/Add'
import LockIcon from '@/media/svg/icon-lock.svg'

class Dashboard extends Component {
  close = () => {
    this.props.dispatch(hideModal())
  }

  remove = record => {
    this.props.dispatch(
      showModal({
        title: 'Permanently delete $title?',
        record: record,
        content:
          `This will permanently delete $title from the newsletter list and ` +
          `it will no logner be accessible to anyone. All related items will ` +
          `remain. This action is irreversible.`,
        buttons: [
          <Button classes="inverted" key="cancel" onClick={this.close}>
            Cancel
          </Button>,
          <Button classes="danger" key="delete" onClick={() => this.delete(record)}>
            Delete
          </Button>,
        ],
      }),
    )
  }

  duplicateModal = record => {
    this.props.dispatch(
      showModal({
        title: 'Duplicate $title?',
        record: record,
        content: `Selected newsletter and its content will be duplicated.`,
        buttons: [
          <Button classes="inverted" key="cancel" onClick={this.close}>
            Cancel
          </Button>,
          <Button classes="success" key="duplicate" onClick={() => this.duplicate(record)}>
            Ok
          </Button>,
        ],
      }),
    )
  }

  duplicate = record => {
    this.props.dispatch(
      crudCreate(
        'newsletters',
        {
          ...record,
          title: `Copy of ${record.title}`,
          data: record.data
            ? record.data.map(el => {
                return {
                  ...el,
                  id: generateUUID(),
                }
              })
            : [], // Fallback to null / undefine / false values - set empty array
        },
        null,
        {
          // ...meta,
          message: `Copy of ${record.title} created.`,
        },
      ),
    )
    // Trigger list loading so we have ordering / pagging right after adding a record

    this.props.dispatch(hideModal())
    setTimeout(() => {
      location.reload() // eslint-disable-line
    }, 400)
    this.forceUpdate()
  }

  delete = record => {
    this.props.dispatch(
      crudDelete('newsletters', record.id, null, { message: `${record.title} deleted.` }),
    )
    this.props.dispatch(hideModal())
  }

  edit = (record, force = false) => {
    if (!force && record.edited_lock && this.props.currentUserId !== record.edited_by.id) {
      this.props.dispatch(
        showModal({
          title: 'Take over editing of $title?',
          record: record,
          content: `This will take over editing of the $title from ${record.edited_by.full_name}.`,
          buttons: [
            <Button classes="inverted" key="cancel" onClick={this.close}>
              Cancel
            </Button>,
            <Button
              classes="inverted"
              key="preview"
              onClick={() => {
                this.preview(record)
                this.close()
              }}
            >
              Preview
            </Button>,
            <Button classes="success" key="edit" onClick={() => this.edit(record, true)}>
              Take over
            </Button>,
          ],
        }),
      )
    } else if (record.status !== 'in-progress') {
      this.props.dispatch(hideModal())
      this.props.dispatch(routeNewslettersEdit(record.id))
    } else {
      this.props.dispatch(hideModal())
      this.props.dispatch(goToPage(ROUTE_NEWSLETTERS_EDIT, null, { id: record.id, step: 'build' }))
    }
  }

  download = record => {
    // this.props.dispatch(showNotification(record.id, `downloading mail template: ${record.title}`))
    this.props.dispatch(checkTemplate(record.id))
  }

  preview = record => {
    fetch(`${process.env.API_URL}/api/build/check/${record.id}`)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return response.text()
        }
        return Promise.reject()
      })
      .then(data => {
        window.open(
          `${process.env.URL}/newsletters/${String(record.id).padStart(4, '0')}/${data}`,
          'preview',
        )
      })
      .catch(err => {
        console.log(err)
      })
  }

  render() {
    const { dispatch, statistics, locale, currentUserId, theme, ...props } = this.props
    const datetimeOptions = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }

    return (
      <Container>
        <Row spacing="double">
          <Cell>
            <Card skipHeader={true}>
              <Row>
                <Cell size="25" classes="bordered-box">
                  EMAILS
                  <h2>{statistics.emails}</h2>
                  <Link to={{ type: ROUTE_NEWSLETTERS_NEW }}>Build newsletter</Link>
                </Cell>
                <Cell size="25" classes="bordered-box">
                  PRODUCTS
                  <h2>{statistics.products}</h2>
                  <Link to={{ type: ROUTE_PRODUCTS_NEW }}>Create new product</Link>
                </Cell>
                <Cell size="25" classes="bordered-box">
                  COMPONENTS
                  <h2>{statistics.components}</h2>
                  <Link to={{ type: ROUTE_COMPONENTS }}>View components</Link>
                </Cell>
                <Cell size="25" classes="bordered-box">
                  TEMPLATES
                  <h2>{statistics.templates}</h2>
                  Soon
                </Cell>
              </Row>
            </Card>
          </Cell>
        </Row>
        <Row>
          <Cell>
            <ListTable
              {...props}
              resource="newsletters"
              title="Newsletters"
              filters={<SearchFilter />}
            >
              <Datagrid startingNo={this.props.startingNo}>
                <IndexField label="Nr." width="calc(2.3rem + 3em)" sortable={false} format={pad} />
                <EditButton source="title" title={false} click={this.edit} theme={theme} />
                <TextField source="product_title" label="Product" />
                <CombinedField
                  label="Edited"
                  cellName="edited"
                  className={`${theme['flex-col']} ${theme['position-relative']}`}
                >
                  <BooleanField
                    source="edited_by"
                    compare={rec => rec.edited_lock && rec.edited_by.id !== currentUserId}
                    whenTrue={<LockIcon className={theme['lock-icon']} />}
                  />
                  <TextField source="edited_by.full_name" tag="div" />
                  <DateField
                    source="edited_at"
                    label="Edited"
                    locales="de"
                    width="7em"
                    options={datetimeOptions}
                  />
                </CombinedField>
                <DateField source="created_at" label="Created" locales="de" width="7em" />
                <DateField source="scheduled_at" label="Scheduled" locales="de" width="8em" />
                <TypeField source="status" width="9em" localize />
                {/* Button doesn't support child events on firefox that's why we are using div */}
                <ButtonGroup width="120px" label="Manage">
                  <ButtonField tag="div" width="2.5em" sortable={false} click={this.duplicateModal}>
                    <Tooltip content="Duplicate newsletter">
                      <AddIcon size="2.5em" />
                    </Tooltip>
                  </ButtonField>
                  <ButtonField tag="div" width="2.5em" sortable={false} click={this.download}>
                    <Tooltip content="Download template">
                      <MailDownloadIcon size="2.5em" />
                    </Tooltip>
                  </ButtonField>
                  <ButtonField tag="div" width="2.5em" sortable={false} click={this.remove}>
                    <Tooltip content="Delete newsletter">
                      <DeleteIcon size="2.5em" />
                    </Tooltip>
                  </ButtonField>
                </ButtonGroup>
              </Datagrid>
            </ListTable>
          </Cell>
        </Row>
      </Container>
    )
  }
}

function mapStateToProps(state, props) {
  return {
    params: getListParams('newsletters')(state),
    statistics: state.rest.statistics.data,
    currentUserId: state.auth.user.id,
    startingNo:
      (state.rest.newsletters.list.params.page - 1) * state.rest.newsletters.list.params.perPage,
  }
}

export default connect(mapStateToProps)(Dashboard)

// export default Dashboard



// WEBPACK FOOTER //
// ./view/Dashboard/Dashboard.js